import {ReactComponent as Ic_Navigation} from 'resources/icons/Ic_Navigation.svg';
import SvgIcon from 'components/commons/icons/SvgIcon';

import './buttonNavigation.scss';
import { CSSProperties } from 'react';

interface IButtonNavigation {
  style?:CSSProperties;
  onClick?: () => void;
}

export default function ButtonNavigation({onClick, style={}}: IButtonNavigation) {
  return (
    <div className='buttonNavigation' onClick={onClick} style={{...style}}>
        <SvgIcon Icon={Ic_Navigation} ariaLabel='icono navegacion' style={{width:'20px',height:'20px'}}/>
    </div>
  );
}
